export const SEARCH_FETCH_STARTED = 'SEARCH_FETCH_STARTED';
export const SEARCH_FETCH_FAILED = 'SEARCH_FETCH_FAILED';
export const SEARCH_FETCH_SUCCEEDED = 'SEARCH_FETCH_SUCCEEDED';
export const FOLDER_FETCH_SUCCEEDED = 'FOLDER_FETCH_SUCCEEDED';
export const SET_SEARCH_QUERY = 'SET_SEARCH_QUERY';
export const SET_SORT = 'SET_SORT';
export const SET_SELECTED_FOLDER = 'SET_SELECTED_FOLDER';
export const SET_VIEW_FILTER = 'SET_VIEW_FILTER';
export const SET_FROM_MODAL = 'SET_FROM_MODAL';
export const SET_FROM_QUERY_PARAMS = 'SET_FROM_QUERY_PARAMS';
export const TOGGLE_FOLDER_SELECTION = 'TOGGLE_FOLDER_SELECTION';
export const TOGGLE_ROW_SELECTION = 'TOGGLE_ROW_SELECTION';
export const ADD_RESULT = 'ADD_RESULT';
export const UPDATE_RESULT = 'UPDATE_RESULT';
export const UPDATE_RESULTS = 'UPDATE_RESULTS';
export const REMOVE_RESULT = 'REMOVE_RESULT';
export const REMOVE_RESULTS = 'REMOVE_RESULTS';
export const REPLACE_RESULT = 'REPLACE_RESULT';
export const REPLACE_RESULT_AFTER_SEARCH = 'REPLACE_RESULT_AFTER_SEARCH';
export const ADD_TEMP_RESULT = 'ADD_TEMP_RESULT';

/* eslint-env commonjs */
// This temporary hack ensures module system compatibility.
// Read more at go/treeshaking
// eslint-disable-next-line hubspot-dev/no-declarations
if (!!module && !!module.exports) {
  module.exports.default = Object.assign({}, module.exports);
}